import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './cookie-policy.component.scss';
var CookiePolicy = /** @class */ (function (_super) {
    tslib_1.__extends(CookiePolicy, _super);
    function CookiePolicy(element) {
        return _super.call(this, element) || this;
    }
    CookiePolicy.prototype.init = function () {
        this.acceptCookieButton = this.element.querySelector('.js-accept-cookie-policy');
        this.cookieBox = this.element;
        // TODO: Remove on go live. For testing purposes only.
        //this.unsetCookies();
        if (typeof (Storage) !== 'undefined' && !localStorage.standardbank) {
            this.toggleCookieBox('open');
        }
    };
    CookiePolicy.prototype.bindEvents = function () {
        var _this = this;
        this.acceptCookieButton.addEventListener('click', function () { return _this.acceptCookies(); });
    };
    CookiePolicy.prototype.toggleCookieBox = function (state) {
        var _this = this;
        if (state === 'open') {
            setTimeout(function () {
                _this.cookieBox.classList.remove('cookie-policy--hidden');
                _this.cookieBox.classList.add('cookie-policy--open');
                _this.cookieBox.classList.remove('cookie-policy--closed');
            }, 5000);
        }
        else {
            this.cookieBox.classList.remove('cookie-policy--open');
            this.cookieBox.classList.add('cookie-policy--closed');
            setTimeout(function () {
                _this.cookieBox.classList.add('cookie-policy--hidden');
            }, 1500);
        }
    };
    CookiePolicy.prototype.acceptCookies = function () {
        this.setCookies();
    };
    CookiePolicy.prototype.setCookies = function () {
        localStorage.standardbank = 'accepted';
        this.toggleCookieBox('closed');
    };
    CookiePolicy.prototype.unsetCookies = function () {
        localStorage.removeItem('standardbank');
        this.toggleCookieBox('open');
    };
    return CookiePolicy;
}(Base));
export { CookiePolicy };



//////////////////
// WEBPACK FOOTER
// ./components/cookie-policy/cookie-policy.component.ts
// module id = 235
// module chunks = 0